// class ReqMsgDTO {

// mid;
// orderId;
// trnAmt;
// trnCurrency;
// trnRemarks;
// meTransReqType;
// recurrPeriod;
// recurrDay;
// noOfRecurring;
// responseUrl;
// addField1;
// addField2;
// addField3;
// addField4;
// addField5;
// addField6;
// addField7;
// addField8;
// addField9;
// addField10;
// reqMsg;
// statusDesc;
// enckey;
// shippingCharges;
// taxAmount;
// grossTrnAmt;
// payTypeCode;
// cardNumber;
// expiryDate;
// nameOnCard;
// cvv;
// pgMeTrnRefNo;
// cancelRefundFlag;
// refundAmt;
// netBankCode;

function ReqMsgDTO() {}

ReqMsgDTO.prototype.getMid = function() {
    return this.mid;
}




ReqMsgDTO.prototype.setMid = function(mid) {
    this.mid = mid;
}




ReqMsgDTO.prototype.getOrderId = function() {
    return this.orderId;
}



ReqMsgDTO.prototype.setOrderId = function(orderId) {
    this.orderId = orderId;
}



ReqMsgDTO.prototype.getTrnAmt = function() {
    return this.trnAmt;
}



ReqMsgDTO.prototype.setTrnAmt = function(trnAmt) {
    this.trnAmt = trnAmt;
}



ReqMsgDTO.prototype.getTrnCurrency = function() {
    return this.trnCurrency;
}



ReqMsgDTO.prototype.setTrnCurrency = function(trnCurrency) {
    this.trnCurrency = trnCurrency;
}



ReqMsgDTO.prototype.getTrnRemarks = function() {
    return this.trnRemarks;
}



ReqMsgDTO.prototype.setTrnRemarks = function(trnRemarks) {
    this.trnRemarks = trnRemarks;
}



ReqMsgDTO.prototype.getMeTransReqType = function() {
    return this.meTransReqType;
}



ReqMsgDTO.prototype.setMeTransReqType = function(meTransReqType) {
    this.meTransReqType = meTransReqType;
}



ReqMsgDTO.prototype.getRecurrPeriod = function() {
    return this.recurrPeriod;
}



ReqMsgDTO.prototype.setRecurrPeriod = function(recurrPeriod) {
    this.recurrPeriod = recurrPeriod;
}



ReqMsgDTO.prototype.getRecurrDay = function() {
    return this.recurrDay;
}



ReqMsgDTO.prototype.setRecurrDay = function(recurrDay) {
    this.recurrDay = recurrDay;
}



ReqMsgDTO.prototype.getNoOfRecurring = function() {
    return this.noOfRecurring;
}



ReqMsgDTO.prototype.setNoOfRecurring = function(noOfRecurring) {
    this.noOfRecurring = noOfRecurring;
}



ReqMsgDTO.prototype.getResponseUrl = function() {
    return this.responseUrl;
}



ReqMsgDTO.prototype.setResponseUrl = function(responseUrl) {
    this.responseUrl = responseUrl;
}



ReqMsgDTO.prototype.getAddField1 = function() {
    return this.addField1;
}



ReqMsgDTO.prototype.setAddField1 = function(addField1) {
    this.addField1 = addField1;
}



ReqMsgDTO.prototype.getAddField2 = function() {
    return this.addField2;
}



ReqMsgDTO.prototype.setAddField2 = function(addField2) {
    this.addField2 = addField2;
}



ReqMsgDTO.prototype.getAddField3 = function() {
    return this.addField3;
}



ReqMsgDTO.prototype.setAddField3 = function(addField3) {
    this.addField3 = addField3;
}



ReqMsgDTO.prototype.getAddField4 = function() {
    return this.addField4;
}



ReqMsgDTO.prototype.setAddField4 = function(addField4) {
    this.addField4 = addField4;
}


ReqMsgDTO.prototype.getAddField5 = function() {
    return this.addField5;
}



ReqMsgDTO.prototype.setAddField5 = function(addField5) {
    this.addField5 = addField5;
}



ReqMsgDTO.prototype.getAddField6 = function() {
    return this.addField6;
}



ReqMsgDTO.prototype.setAddField6 = function(addField6) {
    this.addField6 = addField6;
}



ReqMsgDTO.prototype.getAddField7 = function() {
    return this.addField7;
}



ReqMsgDTO.prototype.setAddField7 = function(addField7) {
    this.addField7 = addField7;
}



ReqMsgDTO.prototype.getAddField8 = function() {
    return this.addField8;
}



ReqMsgDTO.prototype.setAddField8 = function(addField8) {
    this.addField8 = addField8;
}



ReqMsgDTO.prototype.getAddField9 = function() {
    return this.addField9;
}



ReqMsgDTO.prototype.setAddField9 = function(addField9) {
    this.addField9 = addField9;
}



ReqMsgDTO.prototype.getAddField10 = function() {
    return this.addField10;
}



ReqMsgDTO.prototype.setAddField10 = function(addField10) {
    this.addField10 = addField10;
}



ReqMsgDTO.prototype.getReqMsg = function() {
    return this.reqMsg;
}



ReqMsgDTO.prototype.setReqMsg = function(reqMsg) {
    this.reqMsg = reqMsg;
}



ReqMsgDTO.prototype.getStatusDesc = function() {
    return this.statusDesc;
}



ReqMsgDTO.prototype.setStatusDesc = function(statusDesc) {
    this.statusDesc = statusDesc;
}



ReqMsgDTO.prototype.getEnckey = function() {
    return this.enckey;
}



ReqMsgDTO.prototype.setEnckey = function(enckey) {
    this.enckey = enckey;
}



ReqMsgDTO.prototype.getShippingCharges = function() {
    return this.shippingCharges;
}



ReqMsgDTO.prototype.setShippingCharges = function(shippingCharges) {
    this.shippingCharges = shippingCharges;
}



ReqMsgDTO.prototype.getTaxAmount = function() {
    return this.taxAmount;
}



ReqMsgDTO.prototype.setTaxAmount = function(taxAmount) {
    this.taxAmount = taxAmount;
}



ReqMsgDTO.prototype.getGrossTrnAmt = function() {
    return this.grossTrnAmt;
}



ReqMsgDTO.prototype.setGrossTrnAmt = function(grossTrnAmt) {
    this.grossTrnAmt = grossTrnAmt;
}



ReqMsgDTO.prototype.getPayTypeCode = function() {
    return this.payTypeCode;
}



ReqMsgDTO.prototype.setPayTypeCode = function(payTypeCode) {
    this.payTypeCode = payTypeCode;
}



ReqMsgDTO.prototype.getCardNumber = function() {
    return this.cardNumber;
}



ReqMsgDTO.prototype.setCardNumber = function(cardNumber) {
    this.cardNumber = cardNumber;
}



ReqMsgDTO.prototype.getExpiryDate = function() {
    return this.expiryDate;
}



ReqMsgDTO.prototype.setExpiryDate = function(expiryDate) {
    this.expiryDate = expiryDate;
}



ReqMsgDTO.prototype.getNameOnCard = function() {
    return this.nameOnCard;
}



ReqMsgDTO.prototype.setNameOnCard = function(nameOnCard) {
    this.nameOnCard = nameOnCard;
}



ReqMsgDTO.prototype.getCvv = function() {
    return this.cvv;
}



ReqMsgDTO.prototype.setCvv = function(cvv) {
    this.cvv = cvv;
}



ReqMsgDTO.prototype.getPgMeTrnRefNo = function() {
    return this.pgMeTrnRefNo;
}



ReqMsgDTO.prototype.setPgMeTrnRefNo = function(pgMeTrnRefNo) {
    this.pgMeTrnRefNo = pgMeTrnRefNo;
}



ReqMsgDTO.prototype.getCancelRefundFlag = function() {
    return this.cancelRefundFlag;
}



ReqMsgDTO.prototype.setCancelRefundFlag = function(cancelRefundFlag) {
    this.cancelRefundFlag = cancelRefundFlag;
}



ReqMsgDTO.prototype.getRefundAmt = function() {
    return this.refundAmt;
}



ReqMsgDTO.prototype.setRefundAmt = function(refundAmt) {
    this.refundAmt = refundAmt;
}



ReqMsgDTO.prototype.getNetBankCode = function() {
    return this.netBankCode;
}



ReqMsgDTO.prototype.setNetBankCode = function(netBankCode) {
    this.netBankCode = netBankCode;
}

module.exports = ReqMsgDTO;
// }